/**
 * hoveredSurfaceAtom — which surface the rad's mouse is currently over.
 *
 * Drives plain-key hotkey routing: viewer hotkeys (`shift+1..5`, `b`, `n`,
 * `comma`, `period`, arrows, `shift+u/m/s/e/g`, `shift+t/l/b/r/v`) fire
 * unless the rad is hovering the report editor. Modifier hotkeys
 * (`mod+e`, `mod+z`, `ctrl+n`, `ctrl+g`, `alt+1..5`) ignore this atom and
 * fire from anywhere — they're disambiguated by the modifier itself.
 *
 * The mouse, not keyboard focus, is the right gate for the dictation
 * workflow: rad clicks into the report editor (focus is there so
 * dictation lands as text), then mouse-wheel-scrolls the viewer. Pressing
 * `shift+3` to switch to bone preset must work even though keyboard focus
 * is on the editor.
 */

import { atom } from "jotai";

export type HoveredSurface = "viewer" | "editor" | null;

export const hoveredSurfaceAtom = atom<HoveredSurface>(null);
